import { Injectable } from '@angular/core';
import { ApiClient } from '../../services';
import { PublicFile } from '../../models';

@Injectable({
  providedIn: 'root',
})
export class UploadService {
  constructor(private apiClient: ApiClient) {}

  public Upload<T = PublicFile>(formData: FormData, url: string) {
    return this.apiClient.post<T>(url, formData, {
      reportProgress: true,
      observe: 'events',
    });
  }
}
